import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
import API from '../Common/Endpoint/serviceConstrants';

export const callTranslationGetApi = async () => {
    const { data = [] } = await axiosInstanceClient.get(API.dummyapi);
    return data;
};

